export default "__VITE_PUBLIC_ASSET__7cfa20c8__"